module.exports = __webpack_public_path__ + "static/media/truck-left.863f6745.svg";